export default () => (<span className="suggestInput-cross">×</span>)

